import { fetchData } from '@/utils/fetch'

export const retrieveCartList = (data, options) => {
  const queryString = new URLSearchParams(data).toString()
  return fetchData(`/appb/b2b/cart/cartListV2?${queryString}`, options)
}

export const calcShippingFee = (data, options) => {
  return fetchData('/appb/b2b/fee/calcMergeShipFee', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}

export const recordSelectedSku = (data, options) => {
  return fetchData('/appb/b2b/fee/fl', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}

export const removeCart = (data, options) => {
  return fetchData('/appb/b2b/cart/cartDelete', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}

export const updateCart = (data, options) => {
  return fetchData('/appb/b2b/cart/cartUpdate', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}
